import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestAddressModel } from '@shared/interfaces/address.interface';
import { PostCompanyAddressModel, RestCompanyModel, UpdateEmployeeItem } from '@shared/interfaces/companies.interface';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  constructor(private restApiService: RestapiService) {}

  getCompanyList(): Observable<RestCompanyModel[]> {
    return this.restApiService.getData<RestCompanyModel[]>(`Companies`);
  }

  getCompany(companyId: number): Observable<RestCompanyModel> {
    return this.restApiService.getData<RestCompanyModel>(`Companies/${companyId}`);
  }

  addNewCompany(companyModel: RestCompanyModel): Observable<RestCompanyModel> {
    return this.restApiService.create('Companies', companyModel);
  }

  updateCompany(companyModel: RestCompanyModel): Observable<RestCompanyModel> {
    return this.restApiService.update(`Companies/${companyModel.id}`, companyModel);
  }

  deleteCompany(companyId: number): Observable<void> {
    return this.restApiService.delete(`Companies/${companyId}`);
  }

  addEmployeeToCompany(updateEmployeeItem: UpdateEmployeeItem): Observable<boolean> {
    return this.restApiService.associate(
      `Companies/${updateEmployeeItem.companyId}/assignEmployees`,
      updateEmployeeItem.userIds
    );
  }

  deleteEmployeeFromCompany(updateEmployeeItem: UpdateEmployeeItem): Observable<boolean> {
    return this.restApiService.associate(
      `Companies/${updateEmployeeItem.companyId}/removeEmployees`,
      updateEmployeeItem.userIds
    );
  }

  addAddressToCompany(postCompanyAddressModel: PostCompanyAddressModel): Observable<void> {
    return this.restApiService.create(
      `Companies/${postCompanyAddressModel.companyId}/Addresses`,
      postCompanyAddressModel
    );
  }

  updateAddressInCompany(restAddressModel: RestAddressModel, companyId: number): Observable<void> {
    return this.restApiService.update(`Companies/${companyId}/Addresses/${restAddressModel.id}`, restAddressModel);
  }
}
